import { Button, FormGroup, InputLabel, OutlinedInput } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Container, ContainerForm, Title } from '../../../styles/index.sty';
import AlertSnack from '../../../components/Alert/AlertSnack'
import { useAuth } from '../../../context/authContext'
import { useLists } from '../../../context/listContext'
import { insertMaterialData, updateMaterialData } from '../../../api/attributes.api'

export const AddMaterial = () => {
  const { config } = useAuth();
  const { fetchMaterialsList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const formik = useFormik({
    initialValues: {
    material_name: location?.state?.data?.material_name,
    },
    onSubmit: async values => {
      setLoading(true);
      if (location?.state?.data) {
        const submit = await updateMaterialData({...values, product_material_id: location?.state?.data?.product_material_id }, config);
        setResponse(submit);
        setOpen(true);
        fetchMaterialsList();
        if(submit.status === "success") {
          navigate("/materials");
        }
      } else {
        const submit = await insertMaterialData(values, config);
        setResponse(submit);
        fetchMaterialsList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/materials");
        }
      }
    },
  });

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter Material Details.</Title>
      <ContainerForm>
      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader material="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel htmlFor="material_name">Material Name:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="material_name"
            placeholder="Enter Material Name"
            id="material_name"
            type="text"
            value={formik.values.material_name}
            onChange={formik.handleChange}
            />
        </FormGroup>
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            material='info'
            onClick={() => navigate("/materials")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            material='info'
            onClick={formik.handleSubmit}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        </div>}
      </ContainerForm>
    </Container>
    </>
  )
};
